import axiosTokenInstance from 'services/api/backoffice';
import { MERCADOPAGO, MERCADOPAGO_ERROR } from '_models/redux/types';

// Action function
export const mercadoPagoAction =
  (page, size, filters = {}) =>
  async (dispatch) => {
    // Endpoint: Try & Catch
    try {
      const params = { page, size, ...filters };
      const response = await axiosTokenInstance.get(`api/report/v2/transaction-mercadopago`, {
        params,
      });

      const { data, status } = response || {};

      dispatch({
        type: MERCADOPAGO,
        payload: data || {},
        status: status || {},
        method: 'get',
      });
    } catch (e) {
      dispatch({
        type: MERCADOPAGO_ERROR,
        payload: e || {},
      });
    }
  };
